import { CSSProperties } from "react";
import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_PRIMARY_COLOR,
  NOTE_PREVIEW_TABLE_BORDER_COLOR,
  NOTE_PREVIEW_TABLE_HEADER_BACKGROUND,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewTable } from "../note-preview-types";

export interface ReportTableProps {
  table: NotePreviewTable;
  style?: CSSProperties;
}

const cellStyle: CSSProperties = {
  border: `1px solid ${NOTE_PREVIEW_TABLE_BORDER_COLOR}`,
  padding: "4px 6px",
  fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  lineHeight: 1.4,
  verticalAlign: "top",
  textAlign: "left",
};

/** Bordered grid with a shaded header; `thead` repeats when the browser paginates. */
const ReportTable = ({ table, style }: ReportTableProps) => (
  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
      color: NOTE_PREVIEW_TEXT_COLOR,
      marginTop: 4,
      ...style,
    }}
  >
    <thead style={{ display: "table-header-group" }}>
      <tr>
        {table.columns.map((column, index) => (
          <th
            key={index}
            style={{
              ...cellStyle,
              background: NOTE_PREVIEW_TABLE_HEADER_BACKGROUND,
              color: NOTE_PREVIEW_PRIMARY_COLOR,
              fontWeight: 500,
            }}
          >
            {column}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {table.rows.map((row, rowIndex) => (
        <tr key={rowIndex} style={{ breakInside: "avoid" }}>
          {row.map((cell, cellIndex) => (
            <td key={cellIndex} style={cellStyle}>
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export default ReportTable;
